import ActivitiesGroups from './ActivitiesGroups/ActivitiesGroups.vue';
import ActivitiesGroupsCreateEdit from 'src/views/Pages/Dashboard/Work/ActivitiesGroups/ActivitiesGroupsCreateEdit.vue';
import ActivitiesReport from './ActivitiesReport/ActivitiesReport.vue';
import ActivitiesSheets from './ActivitiesReport/ActivitiesSheets.vue';
import ActivityRates from './ActivityRates/ActivityRates.vue';
import ActivityUnits from './ActivityUnits/ActivityUnits.vue';
import ActivityValues from './ActivityValues/ActivityValues.vue';
import ActivityValuesCreateEdit from 'src/views/Pages/Dashboard/Work/ActivityValues/ActivityValuesCreateEdit.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Jobs from './Jobs/Jobs.vue';
import LaborsCatchs from 'src/views/Pages/Dashboard/Work/Catch/Catchs.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import TimeTypes from './TimeTypes/TimeTypes.vue';
import TypeAbsences from './TypeAbsences/TypeAbsences.vue';
import TypeAbsencesCreateEdit from 'src/views/Pages/Dashboard/Work/TypeAbsences/TypeAbsencesCreateEdit.vue';
import TypeContracts from './TypeContracts/TypeContracts.vue';
import Workers from './Workers/Workers.vue';

const WorksRoutes = {
  path: 'works',
  name: 'labor.labours',
  component: MasterTab,
  props: { reference: 'worksTabs' },
  children: [
    {
      path: 'jobs',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: Jobs,
          meta: {
            prefix_permission: 'works_jobs',
          },
        },
      ],
    },
    {
      path: 'workers',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: Workers,
          meta: {
            prefix_permission: 'works_workers',
          },
        },
      ],
    },
    {
      path: 'activityunits',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivityUnits,
          meta: {
            prefix_permission: 'works_activityunits',
          },
        },
      ],
    },
    {
      path: 'typecontracts',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: TypeContracts,
          meta: {
            prefix_permission: 'works_typecontracts',
          },
        },
      ],
    },
    {
      path: 'timetypes',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: TimeTypes,
          meta: {
            prefix_permission: 'works_timetypes',
          },
        },
      ],
    },
    {
      path: 'laborheader',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivitiesReport,
          meta: {
            prefix_permission: 'works_laborheader',
          },
        },
      ],
    },
    {
      path: 'activitysheets',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivitiesSheets,
          meta: {
            prefix_permission: 'works_activitysheets',
          },
        },
      ],
    },
    {
      path: 'activityrates',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivityRates,
          meta: {
            prefix_permission: 'works_activityrates',
          },
        },
      ],
    },
    {
      path: 'activityvalues',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivityValues,
          meta: {
            prefix_permission: 'works_activityvalues',
          },
        },
        {
          path: 'create',
          name: 'labor.labours',
          component: ActivityValuesCreateEdit,
          meta: {
            prefix_permission: 'works_activityvalues',
          },
        },
        {
          path: 'edit',
          name: 'labor.labours',
          component: ActivityValuesCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'works_activityvalues',
          },
        },
      ],
    },
    {
      path: 'activitiesgroups',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: ActivitiesGroups,
          meta: {
            prefix_permission: 'works_activitiesgroups',
          },
        },
        {
          path: 'create',
          name: 'labor.labours',
          component: ActivitiesGroupsCreateEdit,
          meta: {
            prefix_permission: 'works_activitiesgroups',
          },
        },
        {
          path: 'edit',
          name: 'labor.labours',
          component: ActivitiesGroupsCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'works_activitiesgroups',
          },
        },
      ],
    },
    {
      path: 'typeabsences',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'labor.labours',
          component: TypeAbsences,
          meta: {
            prefix_permission: 'works_typeabsences',
          },
        },
        {
          path: 'create',
          name: 'labor.labours',
          component: TypeAbsencesCreateEdit,
          meta: {
            prefix_permission: 'works_typeabsences',
          },
        },
        {
          path: 'edit',
          name: 'labor.labours',
          component: TypeAbsencesCreateEdit,
          props: true,
          meta: {
            prefix_permission: 'works_typeabsences',
          },
        },
      ],
    },
    {
      path: 'catchs',
      name: 'production.capture_labors',
      component: LaborsCatchs,
      meta: { 
        prefix_permission: 'workers_catchs',
      },
    },
  ],
};

export default WorksRoutes;
